import React from 'react';
import Router from './Router';
import { Provider } from 'react-redux';
import { App as AntApp, ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import '@/plugins';
import store from '@/core/store';
import antdTheme from '@/styles/antdTheme';
import 'antd/dist/reset.css';
import '@/styles/App.sass';

// dayjs(value, format) parsing needs this plugin (used by the date inputs).
dayjs.extend(customParseFormat);

// Restore the pre-6.3 mask blur behind modals and the nav drawer
// (ANTD6_DESIGN_RESTORATION.md entry 2). Composes with per-modal
// mask={{ closable: false }}; only unset fields are filled from here.
const maskBlur = { mask: { blur: true } };

// Themes every static message/notification call site (including ones fired
// from redux modules outside the React tree) with zero call-site changes.
// Mirrors every setting the app-level provider below carries.
ConfigProvider.config({
	holderRender: (children) => (
		<ConfigProvider theme={antdTheme} modal={maskBlur} drawer={maskBlur} popupMatchSelectWidth={false}>
			{children}
		</ConfigProvider>
	),
});


const App = () => (
	<Provider store={store}>
		<ConfigProvider theme={antdTheme} modal={maskBlur} drawer={maskBlur} popupMatchSelectWidth={false}>
			<AntApp>
				<Router />
			</AntApp>
		</ConfigProvider>
	</Provider>
);


export default App;
